__webpack_require__.p = "/design-tokens-update/referrals/";